<template>
  <div class="mpf-field pl-3 pr-1 py-2 flex cursor-pointer" @click="this.$emit('configure')">
    <input class="flex-grow d-block h-6 bg-transparent cursor-pointer" :value="value ?? `---`" disabled>
    <ul class="mpf-field-icons flex-shrink">
      <li v-if="!isDefault" class="mpf-field-icons-item">
        <popper class="popper-dark" :content="trans('dashboard.integrations.flows.data_mapping.personalized')" hover arrow :interactive="false" open-delay="200">
          <svg class="icon-1 mx-1">
            <use xlink:href="#not-in-sync-icon"></use>
          </svg>
        </popper>
      </li>
      <li v-if="microFunction" class="mpf-field-icons-item">
        <popper class="popper-dark" :content="trans('dashboard.integrations.flows.data_mapping.micro_function')" hover arrow :interactive="false" open-delay="200">
          <svg class="icon-1 mx-1">
            <use xlink:href="#micro-function-icon"></use>
          </svg>
        </popper>
      </li>
      <li class="mpf-field-icons-item cursor-pointer">
        <popper class="popper-dark" :content="trans('common.configure')" hover arrow :interactive="false" open-delay="200">
          <svg class="icon-1 mx-1">
            <use xlink:href="#settings-icon"></use>
          </svg>
        </popper>
      </li>
    </ul>
  </div>
</template>
<script>
import Popper from "vue3-popper"

export default {
  name: "FlowDataMappingField",

  components: {
    Popper
  },

  emits: ['configure'],

  props: {
    value: String,
    microFunction: String,
    isDefault: Boolean
  },
}
</script>
<style scoped>
.mpf-field-icons {
  list-style-type: none;
}

.mpf-field-icons-item {
  display: inline-block;
}
</style>
